import {createStrokeSVG} from './TEMPLATE'

// tabler: refresh
export const ArrowRotateClockwise_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4',
    'M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// tabler: refresh
export const ArrowRotateCounterClockwise_Stroke2_Corner0_Rounded =
  createStrokeSVG({
    paths: [
      'M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4',
      'M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4',
    ],
    viewBox: '0 0 24 24',
    strokeWidth: 2,
  })
